import Actions from './updater.actions';
import { hasValue } from 'utils';

import initialState from './initialState';

const listHasValue = (result, currentUpdate) => result || hasValue(currentUpdate.value);

const reducer = (state, action) => {
    const { payload = {} } = action;
    const field = payload.field ?? null;
    const value = payload.value ?? null;
    const {updates, updateOptions} = state;

    switch (action.type) {
        case Actions.ADD_SELECTOR:
            return {...state, isSelecting: true};
        case Actions.REMOVE_SELECTOR:
            return {...state, isSelecting: false};
        case Actions.ADD_UPDATER:
            return { ...state,
                     isSelecting: false,
                     updates: [...updates, {field, value}],
                     updateOptions: updateOptions.filter(option => option !== field),
            };
        case Actions.REMOVE_UPDATER:
            return { ...state,
                     updates: updates.filter(update => update.field !== field),
                     updateOptions: [...updateOptions, field].sort(),
                     hasUpdates: updates.filter(update => update.field !== field).reduce(listHasValue, false),
            };
        case Actions.FIELD_VALUE_CHANGED:
            return { ...state,
                     updates: updates.map(update => update.field !== field ? update : {field, value}),
                     hasUpdates: hasValue(value) || updates.filter(update => update.field !== field).reduce(listHasValue, false),
            };
        case Actions.CLEAR:
            return { ...initialState, updateOptions: payload.updateFields };
        case Actions.SAVE:
            return { ...state,
                     saveInvoked: true,
                     updatedAll: payload.updatedAll,
                     updatedIds: payload.updatedIds,
                     failedIds: payload.failedIds
            };
        case Actions.CANCEL_REQUEST:
            return { ...state, showModal: true };
        case Actions.CLOSE_MODAL:
            return { ...state, showModal: false };
        default:
            return { ...state };
    }
};

export default reducer;